<template>
    <div class="image-toggle-selection style-selection page-container">
        <div class="hero-container" :style="{ backgroundImage: 'url(' + imageUrl(heroImage) + ')' }"
             @touchstart="dragstart"
             @touchend="dragend"
        >
            <div class="vertical-align">
                <div class="hero-slide-title">
                    Shop the coolest looks, styled by the industry's best
                </div>
                <router-link to="shop" class="button">
                    Shop Featured
                </router-link>
            </div>
        </div>
    </div>
</template>

<script>
    import SubMenu from '../common/sub-menu.vue';
    import Mixins from '../../mixins/mixins.js';
    import {LANDING_MENU_PAGES} from '../../config.js';

    export default {
        components: {
            SubMenu
        },
        mixins: [Mixins],
        data() {
            return {
                pages: LANDING_MENU_PAGES,
                pageNumber: 2,
                heroImage: 'featured-hero.jpg',
                dragYstart: 0,
                dragThreshold: 50
            }
        },
        methods: {
            visitGetStyled() {
                this.$router.push({path: '/get-styled'});
            },
            dragstart(ev) {
                this.dragYstart = ev.touches[0].pageY;
            },
            dragend(ev) {
                if (this.dragYstart - ev.changedTouches[0].pageY > this.dragThreshold) {
                    this.$router.push({path: '/shop'});
                }
                this.dragYstart = 0;
            }
        },
    }
</script>